import { useEffect, useRef, useState } from "react";
import { VideoContext } from "./contexts/VideoContext";
import Viewport from "./components/Viewport";
import { AppDebugSettings } from "./contexts/DebugSettingsContext";
import MediaSourcePlayer from "./utils/video/MediaSourcePlayer";
import AudioContextProvider from "./contexts/AudioContext";
import { LOGS } from "./utils/logging";

function App() {
	const videoManagerRef = useRef<MediaSourcePlayer | null>(null);
	const [debugSettings, setDebugSettings] = useState<AppDebugSettings>({
		showHitBox: false,
		showLoggingOverlay: false,
		showVolumeOverlay: false,
	});

	useEffect(() => {
		const handleKeyDown = (e: KeyboardEvent) => {
			LOGS.INTERACTIVE &&
				console.log("Key pressed:", e.key, "Code:", e.code, "KeyCode:", e.keyCode);
			if (e.key === "1") {
				LOGS.INTERACTIVE && console.log("show hitbox toggled");
				setDebugSettings((prev: AppDebugSettings) => ({
					...prev,
					showHitBox: !prev.showHitBox,
				}));
			}
			if (e.key === "2") {
				LOGS.INTERACTIVE && console.log("show volume overlay toggled");
				setDebugSettings((prev: AppDebugSettings) => ({
					...prev,
					showVolumeOverlay: !prev.showVolumeOverlay,
				}));
			}
		};
		window.addEventListener("keydown", handleKeyDown);
		return () => window.removeEventListener("keydown", handleKeyDown);
	}, []);

	return (
		<AppDebugSettings.Provider value={debugSettings}>
			<AudioContextProvider>
				<VideoContext.Provider value={{ videoManagerRef }}>
					<Viewport />
				</VideoContext.Provider>
			</AudioContextProvider>
		</AppDebugSettings.Provider>
	);
}

export default App;
